module.exports = __webpack_public_path__ + "img/cara-img.ca849afc.svg";